// extracted by mini-css-extract-plugin
export default {"wrapper":"Mk","form":"Nk","option":"Ok","radio":"Pk","success":"Qk","contest":"Rk"};